import React, { useEffect, useState } from 'react'
import axios from "axios"
import { useSelector } from "react-redux"
import {loadStripe} from '@stripe/stripe-js';
import { isLength, isMatch } from "../../utils/validation/Validation"
import "./profile.css"
import { toast } from 'react-toastify';
import Loader from '../../utils/Loader'
import userIcon from "../../../Images/userImage.png"

// PRODUCTION
const PUBLIC_KEY_STRIPE = 'pk_live_51M28Y2D4mKWV2kEH04YWOpCVLdNfPJrUPHtHbv2n7ZHIAkS5CNfKtPoNMeT0viQUM10SWeGkczEO5HPFyU2hG7Zh006L3YwEOK'

const Profile = () => {
    const token = useSelector(state => state.token)
    const user = JSON.parse(localStorage.getItem('login'))
    const [data, setData] = useState({ name: "", email:"", password: "", cf_password: "" })
    const [stripe, setStripe] = useState('')
    const [loading, setLoading] = useState(true)
    const { name, email, password, cf_password } = data
    const [subscribed, setSubscribed] = useState(false)

    useEffect(async () => {

        let s = await loadStripe(PUBLIC_KEY_STRIPE);
        setStripe(s)
        if(user.billingID){
            const res = await axios.post('https://iq-screener-backend-a7au.vercel.app/api/payment/checkSubscription', { billingId: user.billingID, email })
            if(res.data === true) {
                setSubscribed(res.data)
            }
        }

        setData({ name: "", email:user.email, password: "", cf_password: "" })
        setLoading(false)

    }, [])

    const handleChange = e => {
        const { name, value } = e.target
        setData({ ...data, [name]: value })
    }

    const updatePassword = async () => {

        if (isLength(password)) {
            toast.error('Password must be at least 6 characters length', {containerId:'DisplayInfo', theme: "colored" });
            setData({ ...data })
            return
        }
        if (!isMatch(password, cf_password)) {
            toast.error('Password does not match', {containerId:'DisplayInfo', theme: "colored" });
            setData({ ...data })
            return
        }

        try {
            let res = await axios.post('https://iq-screener-backend-a7au.vercel.app/api/user/reset', {password, email: user.email}, 
            {
                headers: { Authorization: token }
            })
            
            if(res.data.msg === "Logged out successfully"){
                toast.success('Updated Succesfully !', {containerId:'DisplayInfo', theme: "colored" });
                localStorage.removeItem("firstLogin");
                localStorage.removeItem("login");
                localStorage.removeItem("userEmail");
                localStorage.removeItem("dataType");
                localStorage.removeItem("dataAlert");
                window.location.href = "/";
            }

        } catch (err) {
            toast.error('Error !', {containerId:'DisplayInfo', theme: "colored" });
            setData({ ...data })
        }
    }

    const updateInfor = async () => {
        try {
            let res = await axios.post('https://iq-screener-backend-a7au.vercel.app/api/user/update', {
                name: name ? name : user.name,
                email: user.email
            }, {
                headers: { Authorization: token }
            })

            setData({ ...data })
            if(res.status === 200){
                let updateUser = {isLogged: true, email: user.email, billingID: user.billingID, name: name, password: user.password}
                localStorage.setItem('login', JSON.stringify(updateUser));
                if(password){
                    updatePassword()
                }else{
                    return true
                }
            }

        } catch (err) {
            toast.error('Error !', {containerId:'DisplayInfo', theme: "colored" });
            setData({ ...data })
        }
    }

    const handleUpdate = async () => {
        if (name){
            let update = await updateInfor()
            if(update === true) {
                toast.success('The Name Updated Succesfully!', {containerId:'DisplayInfo', theme: "colored" })
                window.location.reload(true)
            }
        }
        else if (password) updatePassword()
        else toast.error('There is Nothing to update!', {containerId:'DisplayInfo', theme: "colored" });
    }

    const handleSubscription = async e => {
        setLoading(true)
        e.preventDefault()
        // STRIPE PRODUCT NAME
        const product = 'pro';
        const customer = user.billingID
        // Call your backend to create the Checkout Session
        try {
            await fetch('https://iq-screener-backend-a7au.vercel.app/api/payment/checkout', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'email': email,
                    'Authorization': token 
                  },
                  body: JSON.stringify({
                    email,
                    product,
                    customerID: customer
                  })
            })
            .then(function(response) {
                return response.json();
            })
            .then(function(session) {
                stripe.redirectToCheckout({ sessionId: session.session });
            })

        }catch(err){
            err && toast.error(`${err} !`, {containerId:'DisplayInfo', theme: "colored" });
            setLoading(false)
        }
    }

    return (
        <div className="profile_page">
            {loading ? <Loader /> :
            <React.Fragment>
                {/* PORFILE EDIT */}
                <div className="profile-container">
                    <div className='image-container'>
                        <div className="avatar">
                            <img src={userIcon} alt=""  className='userImage'/>
                        </div>
                        <h2>{user.name}</h2>
                    </div>
                    <div className="form_group">
                        <label htmlFor="name">New Name</label>
                        <input type="text" name="name" className='label-input form-control'
                            placeholder="Enter name" value={name} onChange={handleChange} />
                    </div>
                    <div className="form_group">
                        <label htmlFor="email">Email</label>
                        <input type="email" name="email" className='label-input form-control'
                            placeholder="Enter email" value={email} defaultValue={user.email} disabled />
                    </div>
                    <div className="form_group">
                        <label htmlFor="password">New Password</label>
                        <input type="password" name="password" className='label-input form-control'
                            placeholder="Enter Password" value={password} onChange={handleChange} />
                    </div>
                    <div className="form_group">
                        <label htmlFor="cf_password">Confirm Password</label>
                        <input type="password" name="cf_password" className='label-input form-control'
                            placeholder="Confirm Password" value={cf_password} onChange={handleChange} />
                    </div>
                    <button className="btn btn-success" style={{ backgroundColor: '#0d9460', color: 'white', fontSize: '16px', padding: '6px 40px', borderRadius: '5px', margin: '10px 0px', cursor: 'pointer' }} 
                    disabled={loading} onClick={handleUpdate}>Update</button>
                </div>

                {/* SUBSCRIPTION PLAN */}
                <div class="subscription-container">
                    { !subscribed && 
                    <div class="whole">
                        <div class="type">
                            <p>FREE</p>
                            </div>
                        <div class="plan">

                            <div class="header">
                                <span>€</span>0.00
                                <p class="month">per month</p>
                            </div>
                            <div class="content">
                                <ul>
                                    <li>Données sur plus de 300 monnaies</li>
                                    <li>Configurer jusqu'à 10 alertes</li>
                                    <li>12 différents sons d'alerte</li>
                                </ul>

                            </div>
                            
                            <div class="price">
                                <a href="#" class="bottom" style={{cursor: 'default'}}>
                                    <p class="cart">Current Plan</p>
                                </a>
                            </div>
                        </div>
                    </div>
                    }
                    <div class="whole">
                        <div class="type standard">
                            <p>PREMIUM</p>
                        </div>
                        <div class="plan">

                            <div class="header">
                                <span>€</span>9.99
                                <p class="month">per month</p>
                            </div>
                            <div class="content">
                                <ul>
                                    <li>Colonnes 10s, 20s et 30s</li>
                                    <li>Notification par e-mail pour l'alerte</li>
                                    <li>Service d'assistance </li>
                                </ul>
                            </div>
                            <div className={subscribed ? "price" : "price start-free"}>
                                {subscribed ?
                                    <a href="#" className="bottom" style={{cursor: 'default'}}> 
                                        <p class="cart">Current Plan</p>
                                    </a> 
                                    :
                                    <a href="#" className="bottom" onClick={handleSubscription}> 
                                        <p class="cart">Start a Free Trial</p>
                                    </a> 
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
            }
        </div>
    )
}

export default Profile